import { render, staticRenderFns } from "./CollapsingContainer.vue?vue&type=template&id=53346405&scoped=true"
import script from "./CollapsingContainer.vue?vue&type=script&lang=js"
export * from "./CollapsingContainer.vue?vue&type=script&lang=js"
import style0 from "./CollapsingContainer.vue?vue&type=style&index=0&id=53346405&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53346405",
  null
  
)

export default component.exports